// extracted by mini-css-extract-plugin
export default {"container":"WrapperSendButton_container__-rIk-","sendIcon":"WrapperSendButton_sendIcon__pOb3L"};